module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects fk__projects"
  }, [_c('div', {
    staticClass: "fk__projects__bg--texture"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__projects__bg--orange"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__projects__gradient"
  }), _vm._v(" "), _c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__projects__heading"
  }, [_vm._v("Check Out Our Projects")]), _vm._v(" "), _c('div', {
    staticClass: "fk__projects__container",
    attrs: {
      "id": "js__projects__container"
    }
  }, [_c('router-link', {
    staticClass: "fk__projects__project",
    attrs: {
      "to": "/projects/mustard-seed"
    }
  }, [_c('img', {
    staticClass: "fk__projects__project__poster",
    attrs: {
      "src": require("../assets/posters/mustardSeed.jpg")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__projects__project__title"
  }, [_vm._v("Mustard Seed")])]), _vm._v(" "), _c('router-link', {
    staticClass: "fk__projects__project",
    attrs: {
      "to": "/projects/honduras-ministries"
    }
  }, [_c('img', {
    staticClass: "fk__projects__project__poster",
    attrs: {
      "src": require("../assets/posters/hondurasMinistries.jpg")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__projects__project__title"
  }, [_vm._v("Honduras Ministries")])]), _vm._v(" "), _c('router-link', {
    staticClass: "fk__projects__project",
    attrs: {
      "to": "/projects/a-bright-future-for-kids"
    }
  }, [_c('img', {
    staticClass: "fk__projects__project__poster",
    attrs: {
      "src": require("../assets/posters/aBrightFutureForKids.jpg")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__projects__project__title"
  }, [_vm._v("A Bright Future For Kids")])]), _vm._v(" "), _c('router-link', {
    staticClass: "fk__projects__project",
    attrs: {
      "to": "/projects/velvet-ashes"
    }
  }, [_c('img', {
    staticClass: "fk__projects__project__poster",
    attrs: {
      "src": require("../assets/posters/velvetAshes.jpg")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__projects__project__title"
  }, [_vm._v("Velvet Ashes")])]), _vm._v(" "), _c('div', {
    staticClass: "fk__projects__arrow fk__projects__arrow--left",
    attrs: {
      "id": "js__projects__arrow__left"
    }
  }, [_c('svg', {
    staticClass: "fk__projects__arrow__svg fk__projects__arrow__svg--left",
    attrs: {
      "viewBox": "0 0 100 100",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.664 31.332L50 68.67 87.34 31.33",
      "fill": "none",
      "stroke": "#fff",
      "stroke-width": "16.38627"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fk__projects__arrow fk__projects__arrow--right",
    attrs: {
      "id": "js__projects__arrow__right"
    }
  }, [_c('svg', {
    staticClass: "fk__projects__arrow__svg fk__projects__arrow__svg--right",
    attrs: {
      "viewBox": "0 0 100 100",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.664 31.332L50 68.67 87.34 31.33",
      "fill": "none",
      "stroke": "#fff",
      "stroke-width": "16.38627"
    }
  })])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25916ac4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects.vue
// module id = 74
// module chunks = 0